<template src="./AppHeader.html"></template>
<style scoped src="./AppHeader.css"></style>

<script>
import {mapGetters, mapActions, mapState} from 'vuex'
import AuthenticationService from '@/services/AuthenticationService.vue'
import Burger from './burger/Burger'
import Loading from 'vue-loading-overlay'
import md5 from 'crypto-js/md5'

export default {
  name: 'app-header',
  components: {
    Burger, Loading
  },
  props: {
    isTransparent: Boolean,
    isWhiteLogo: Boolean
  },
  data () {
    return {
      isActiveDropdown: false,
      loaderVisible: false
      // user: null
    }
  },
  watch: {
    getUser (newVal, oldVal) {
    }
  },
  methods: {
    ...mapActions(['fetchUser', 'parseUserFromLocalStorage']),
    logout () {
      this.$store.commit('updateTransactionNexusSummary', [])
      this.$store.commit('updateTransactionSummary', [])
      this.$session.destroy()
      AuthenticationService.methods.logout()
      this.$router.push({
        name: 'Login'
      })
    },
    setActive (menuItem) {
      this.$parent.activeItem = menuItem
    },
    setCommitWindowWidth () {
      return () => this.$store.commit('setWindowWidth')
    },
    setCommitWindowHeight () {
      return () => this.$store.commit('setWindowHeight')
    },
    setActiveDropdown () {
      this.isActiveDropdown = !this.isActiveDropdown
    },
    handleMyTransaction () {
      if (this.$parent.name === 'Home') {
        this.$parent.activeItem = 'transaction-history'
      } else {
        this.$router.push({name: 'Home', params: {activeItem: 'transaction-history'}})
      }
    },
    addMerchantRMSSessionId () {
      const aid = 10377
      const sessId = this.$session.id()
      const session = md5(sessId.split('sess:')[1]).toString().toString()
      let merchantRMSScript = document.createElement('script')
      merchantRMSScript.setAttribute('type', 'text/javascript')
      merchantRMSScript.setAttribute('async', 'true')
      merchantRMSScript.setAttribute('src', `https://elistva.com/api/script.js?aid=${aid}&sid=${session}`)
      document.head.appendChild(merchantRMSScript)

      let merchantRMSNoScript = document.createElement('noscript')
      let merchantRMSNoScriptP = document.createElement('p')
      merchantRMSNoScriptP.setAttribute('style', `background:url(//elistva.com/api/assets/clear.png?aid=${aid}&sid=${session})`)
      merchantRMSNoScript.appendChild(merchantRMSNoScriptP)
      document.head.appendChild(merchantRMSNoScript)

      let merchantRMSObject = document.createElement('object')
      let merchantRMSObjectPath = document.createElement('param')
      merchantRMSObject.setAttribute('type', 'application/x-shockwave-flash')
      merchantRMSObject.setAttribute('data', `//elistva.com/api/udid.swf?aid=${aid}&sid=${session}`)
      merchantRMSObject.setAttribute('width', '1')
      merchantRMSObject.setAttribute('height', '1')
      merchantRMSObjectPath.setAttribute('name', 'movie')
      merchantRMSObjectPath.setAttribute('value', `//elistva.com/api/udid.swf?aid=${aid}&sid=${session}`)
      merchantRMSObject.appendChild(merchantRMSObjectPath)
      document.head.appendChild(merchantRMSObject)
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getIsSidebarOpen', 'getWindowWidth', 'getWindowHeight', 'isVertical', 'isSmall', 'isLarge']),
    ...mapState(['transactionSummary'])
  },
  created () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.setCommitWindowWidth())
      window.addEventListener('resize', this.setCommitWindowHeight())
    })
  },
  async mounted () {
    this.loaderVisible = true
    // if (localStorage.getItem('user-auth') /* && ['Delivery Method', 'Delivery Method (Home)'].includes(this.$route.name) */) {
    //   await this.fetchUser()
    // } else {
    //   await this.parseUserFromLocalStorage()
    // }
    if (this.$session.exists()) {
      this.addMerchantRMSSessionId()
    } else {
      this.$store.commit('updateUser', null)
    }
    this.loaderVisible = false
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setCommitWindowWidth())
    window.removeEventListener('resize', this.setCommitWindowHeight())
  },
  beforeCreate () {
    if (!this.$session.exists() && !['Landing', 'Support', 'Contact', 'Privacy', 'User Agreement', 'Sitemap'].includes(this.$route.name)) {
      AuthenticationService.methods.logout()
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/AppHeader.vue